<template>
  <el-dialog v-dialog-drag :title="title" :visible.sync="showPermissionDialog" width="600px" :destroy-on-close="true"
             :before-close="cancel">
<!--    <div class="el-dialog-div">-->
      <el-form label-width="120px" ref="form" :model="form" :rules="rules">
        <el-form-item label="商务专员" prop="tradeCommissionerUuid">
          <el-select v-model="form.tradeCommissionerUuid" :disabled="trade" filterable clearable placeholder="请选择"
                     style="width: 270px">
            <el-option
                v-for="item in tradeOption"
                :key="item.uuid"
                :label="item.name"
                :value="item.uuid"
                :disabled="item.disabled">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公司" prop="companyIds">
          <el-select v-model="form.companyIds" filterable multiple placeholder="请选择" style="width: 270px">
            <el-option
                v-for="item in companyOption"
                :key="item.id"
                :label="item.companyName"
                :value="item.id"
                :disabled="!item['companyInvoiceStatus']">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="销售" prop="salesManagerUuid">
          <el-select v-model="form.salesManagerUuid" filterable multiple placeholder="请选择" style="width: 270px">
            <el-option
                v-for="item in salesOption"
                :key="item.uuid"
                :label="item.name"
                :value="item.uuid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
              style="width: 270px"
              type="textarea"
              :autosize="{ minRows: 3}"
              maxlength="300"
              show-word-limit
              placeholder="请输入内容"
              v-model="form.remark"
              clearable>
          </el-input>
        </el-form-item>
      </el-form>
<!--    </div>-->
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="cancel">取消</el-button>
      <el-button size="small" type="primary" class="title" @click="handle">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {getPersonByType} from "@/api/dilivery/customer/person";
import {getCompanyPage} from "@/api/dilivery/company";
import {addPermission, editPermission, getPermissionPage} from "@/api/dilivery/permission";

export default {
  name: "AddPermission",
  props: ['showPermissionDialog', 'selectType', 'selectDetail'],
  data() {
    return {
      trade: false,
      tradeOption: [],
      salesOption: [],
      companyOption: [],
      title: '',
      form: {
        remark: '',
        salesManagerUuid: [],
        companyIds: [],
        tradeCommissionerUuid: ''
      },
      rules: {
        tradeCommissionerUuid: [
          {required: true, message: '商务专员不能为空', trigger: 'change'}
        ],
        companyIds: [
          {
            validator: this.validateCompanyOrSales,
            trigger: 'change'
          }
        ],
        salesManagerUuid: [
          {
            validator: this.validateCompanyOrSales,
            trigger: 'change'
          }
        ]
      }
    }
  },
  mounted() {
    this.getTradeOption();
    this.getSalesOptions();
    this.getCompanyOptions();
  },
  watch: {
    'selectType': {
      handler(newVal) {
        if (newVal) {
          if (newVal.type === 'edit') {
            this.title = '编辑权限信息'
            this.trade = true
          } else {
            this.title = '添加权限信息'

          }
        }
      },
      immediate: true
    },
    'selectDetail': {
      handler(newVal) {
        if (newVal && Object.keys(newVal)) {
          this.form.id = newVal.id
          this.form.remark = newVal.remark
          this.form.companyIds = newVal.companyIds
          this.form.salesManagerUuid = newVal.salesManagerUuid
          this.form.tradeCommissionerUuid = newVal.tradeCommissionerUuid
        }
      },
      immediate: true
    },
  },
  methods: {
    async someAsyncFunction() {
      let params = {
        'page.current': 1,
        'page.size': 100000
      }
      await getPermissionPage(params, {}).then(res => {
        if (res.code === 200) {
          this.table = res.data.records
        }
      }).catch(() => {
      })
    },
    validateCompanyOrSales(rule, value, callback) {
      if (!this.form.companyIds.length && !this.form.salesManagerUuid.length) {
        callback(new Error('公司和销售至少选择一个'));
      } else {
        callback();
      }
    },
    cancel() {
      this.$emit('submit', 'cancel')
    },
    async getTradeOption() {
      await this.someAsyncFunction();
      try {
        let data = {
          "isManager": "false"
        }
        getPersonByType('BUSINESS', data).then(res => {
          if (res.code === 200) {
            this.tradeOption = res.data
            if (this.selectType.type === 'add') {
              this.tradeOption.forEach(itemA => {
                itemA.disabled = this.table.some(itemB => itemB.tradeCommissionerUuid === itemA.uuid) // 如果 id 相同则 disabled 为 true
              });
            }
          }
        })
      } catch (error) {
        console.log(error);
      }
    },
    getSalesOptions() {
      try {
        let data = {}
        getPersonByType('SALES', data).then(res => {
          if (res.code === 200) {
            this.salesOption = res.data.filter(item => item.isManager)
          }
        })
      } catch (error) {
        console.log(error);
      }
    },
    getCompanyOptions() {
      try {
        let param = {
          'page.current': 1,
          'page.size': 100000,
          'order': 'id.asc'
        }
        getCompanyPage(param, {}).then(res => {
          if (res.code === 200) {
            this.companyOption = res.data.records
          }
        })
      } catch (error) {
        console.log(error);
      }
    },
    handle() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.selectType.type === 'add') {
            addPermission(this.form).then(res => {
              if (res.code === 200) {
                this.$emit('submit', 'confirm')
                this.$messageUi.success('添加成功')
              }
            }).catch(err => {
            })
          } else {
            editPermission(this.form).then(res => {
              if (res.code === 200) {
                this.$emit('submit', 'confirm')
                this.$messageUi.success('修改成功')
              }
            }).catch(err => {
            })
          }
        } else {
          this.$nextTick(() => {
            let err = document.getElementsByClassName('is-error')
            if (err.length) {
              err[0].scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              })
            }
          })
          this.$messageUi.error('填写参数不规范，请检查')
        }
      });


    }
  }
}
</script>

<style scoped>

</style>
